import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { CheckCircle } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    title: 'The Step-by-Step Master Guide (PDF)',
    description: 'Exactly what to do Friday, Saturday, Sunday, and Monday'
  }, {
    title: 'The "Target/Walmart" Shopping List',
    description: 'No guessing, no extra gadgets'
  }, {
    title: 'Hydrate + Observe Protocol',
    description: 'Controlled fluids to create more learning opportunities (fast)'
  }, {
    title: 'Daycare Teacher Script',
    description: "What to say so they don't put your child back in a diaper"
  }, {
    title: 'Accident Map Tracker',
    description: 'Spot patterns and prevent repeat accidents'
  }, {
    title: 'Sunday Night Emergency FAQ',
    description: "Quick answers when you're tired and second-guessing everything"
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 px-4" data-id="element-217">
      <div className="max-w-5xl mx-auto" data-id="element-218">
        <div className="text-center mb-16" data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-220">
            Everything Inside Your Guide
          </h2>
          <p className="text-xl text-foreground/70" data-id="element-221">
            When you download Goodbye Diapers in 3 Days, you get:
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-222">
          {items.map((item, index) => <motion.div key={index} variants={itemVariants} data-id="element-223">
              <Card className="h-full hover:shadow-lg transition-shadow duration-300 border-t-4 border-t-primary" data-id="element-224">
                <div className="flex items-start gap-4" data-id="element-225">
                  <div className="bg-primary/10 rounded-full p-1 mt-0.5" data-id="element-226">
                    <CheckCircle className="w-6 h-6 text-primary flex-shrink-0" data-id="element-227" />
                  </div>
                  <div data-id="element-228">
                    <h3 className="text-lg font-bold text-foreground mb-2" data-id="element-229">
                      {item.title}
                    </h3>
                    <p className="text-foreground/70 leading-relaxed" data-id="element-230">
                      {item.description}
                    </p>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}